import React from "react";
// import { Link } from "react-router-dom";
import "./CardProduct.css";
import { useState } from "react";
import { Link } from "react-router-dom";
function CardProduct(props) {
    const [imgState, setimgState] = useState(props.img);
    return ( <Link to="/addcart">
        <div className="card">
           
            <img onMouseEnter={() => {
                setimgState(props.imgUrl);
            }}
                onMouseLeave={() => {
                    setimgState(props.img);
                }}
                src={imgState} alt="" />
            <div className="card_details">
                <h4 className="card_title">{props.title}</h4>
                <p className="card_link">{props.price}</p>
            </div>
        </div></Link>

    );
}

export default CardProduct;